@if (isLogoutPage()) {
  <div class="flex flex-column ml-4" [style]="{width: '60rem'}">
    <div class="flex content-start">
      <img ngSrc="/images/DZBANK_Logo_oC_pos_RGB.svg" priority alt="DZ BANK Logo" height="80" width="248"
           class="mr-2"/>
    </div>
    <div class="ml-6">
      <router-outlet></router-outlet>
    </div>
  </div>
} @else if (showErrorPage()) {
  <div class="flex flex-column ml-4" [style]="{width: '60rem'}">
    <div class="flex content-start">
      <img ngSrc="/images/DZBANK_Logo_oC_pos_RGB.svg" priority alt="DZ BANK Logo" height="80" width="248"
           class="mr-2"/>
    </div>
    <div class="ml-6">
      <router-outlet></router-outlet>
    </div>
    <p-button icon="pi pi-sign-in" class="ml-6 mt-3" label="Zurück zum Login" (onClick)="backToLogin()"/>
  </div>
} @else {
  @if (authenticated) {
    <div class="flex flex-column h-full overflow-x-hidden mb-1">
      <header class="flex-shrink-0 w-full flex flex-column">
        <app-header class="flex-1 h-full"></app-header>
      </header>
      <div class="flex-grow-1 flex flex-row overflow-hidden">
        <nav class="flex-grow-1 hidden xl:block lg:block md:hidden sm:hidden mb-2">
          <app-navbar></app-navbar>
        </nav>
        <div class="flex flex-column w-full overflow-auto">
          <main class="flex-grow-1 p-5">
            <p-toast></p-toast>
            <router-outlet></router-outlet>
          </main>
          <footer class="flex-shrink-0 w-full">
            <app-footer></app-footer>
          </footer>
        </div>
      </div>
    </div>
  } @else {
    <p-progressSpinner class="flex h-30rem "></p-progressSpinner>
  }
}
